import type React from 'react';
import type { JournalEntry } from '@/api/models';
import { JournalEntryFormView } from './JournalEntryFormView';
import { useJournalEntryForm } from './useJournalEntryForm';

export type JournalEntryFormProps = {
    /** An existing draft to edit; omit for a fresh entry. */
    entry?: JournalEntry | null;
    /** Fired after a successful save or post, with the server's entry. */
    onSaved?: (entry: JournalEntry) => void;
    /** Optional cancel affordance (shown when hosted in a modal). */
    onCancel?: () => void;
};

/**
 * Self-contained Journal Entry form — compose, save, and post a balanced
 * double-entry transaction. Decoupled from any host: mount it at a route or
 * inside a modal (see `JournalEntryModal`); the future journal list can drop it
 * in and pass `entry` + `onSaved`.
 */
export const JournalEntryForm: React.FC<JournalEntryFormProps> = ({
    entry = null,
    onSaved,
    onCancel,
}) => {
    const form = useJournalEntryForm({ entry, onSaved });
    return <JournalEntryFormView form={form} onCancel={onCancel} />;
};
